import React from 'react';

import Layout from '../Layout';
import PotockLink from '../PotockLink';
import SEO from '../SEO';

/**
 * Wspólna oprawa obu podstron z koncertami: nagłówek, przełącznik
 * nadchodzące/archiwum oraz wskaźnik odświeżania listy z API.
 */
function KoncertyStrona({
  tytul,
  opisSeo,
  aktywnaZakladka,
  wczytywanie,
  children,
}) {
  const klasaZakladki = nazwa =>
    aktywnaZakladka === nazwa ? 'koncerty-zakladka--aktywna' : '';

  return (
    <Layout shop={true}>
      <SEO pageTitle={tytul} pageDescription={opisSeo} />

      <div
        className="px-6 pt-24 pb-20 container mx-auto w-full block text-white"
        style={{ maxWidth: '820px' }}
      >
        <h1 className="text-center text-3xl uppercase mb-8">Koncerty</h1>

        <nav className="koncerty-zakladki">
          <PotockLink to="/koncerty" className={klasaZakladki('nadchodzace')}>
            Nadchodzące
          </PotockLink>
          <PotockLink
            to="/koncerty/archiwum"
            className={klasaZakladki('archiwum')}
          >
            Archiwum
          </PotockLink>
        </nav>

        <p
          className="koncerty-loader"
          aria-live="polite"
          style={{ visibility: wczytywanie ? 'visible' : 'hidden' }}
        >
          {wczytywanie ? 'Wczytuję aktualną listę' : ''}
        </p>

        {children}
      </div>
    </Layout>
  );
}

export default KoncertyStrona;
